import { type ForwardedRef, forwardRef } from 'react';

import { Box, CircularProgress, Stack, Typography } from '@mui/material';

import { DECOMPOSITION_TREE_TEST_ID } from '../testIds';

type Props = {
  active: boolean;
  isFetching: boolean;
  loadingLabel?: string;
};

export const InfiniteScrollSentinel = forwardRef(function InfiniteScrollSentinel(
  { active, isFetching, loadingLabel = 'Loading more…' }: Props,
  ref: ForwardedRef<HTMLDivElement>
) {
  if (!active) return null;

  return (
    <Box
      ref={ref}
      data-testid={DECOMPOSITION_TREE_TEST_ID.infiniteScrollSentinel}
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 1, minHeight: 32 }}
    >
      {isFetching ? (
        <Stack direction='row' spacing={1} alignItems='center'>
          <CircularProgress size={16} />
          <Typography variant='caption' color='text.secondary'>
            {loadingLabel}
          </Typography>
        </Stack>
      ) : null}
    </Box>
  );
});
